// types you already have in the AddressSearch package
import type { GroupSuggestion } from "../index";

type LoqateItem = { Id: string; Text: string; Description: string; Type: string };

// --- helpers (generic) ---
const extractCount = (s: string) => {
  const m = /(?:^|\D)(\d{1,6})\s+Addresses?/i.exec(s || "");
  return m ? Number(m[1]) : undefined;
};

const firstToken = (s: string) =>
  (s || "")
    .split(/(?:\s*-\s*\d+\s+Addresses?\s*)|,|\s+/)
    .filter(Boolean)[0] || "";

const looksLikeCode = (s: string) =>
  /\d/.test(s) || /\s/.test(s) || (s || "").length >= 3;

// --- main mapper ---
export function mapLoqateGroupsGeneric(
  items: LoqateItem[],
  opts: {
    formatDescription: (s: string) => string; // e.g. LoqateConfig.formatDescription
    isAddressType: (t: string) => boolean;    // e.g. LoqateConfig.isAnAddress
  }
): GroupSuggestion[] {
  const { formatDescription, isAddressType } = opts;

  return items
    .filter(i => !isAddressType(i.Type))
    .map<GroupSuggestion>((i) => {
      const textRaw = (i.Text || "").trim();
      const descFull = (formatDescription(i.Description) || "").trim();
      const count = extractCount(descFull);
      const desc = descFull.replace(/\s*-\s*\d+\s+Addresses?/i, "").trim();

      const code = looksLikeCode(textRaw) ? textRaw : firstToken(desc) || textRaw;

      const label =
        desc && !desc.toLowerCase().startsWith(code.toLowerCase())
          ? `${code} ${desc}`
          : (desc || code);

      return { id: i.Id, code, label, count };
    });
}
